import EventEmitter from 'owa-event-emitter';
import { executeDiagnosticsTask } from '../utils/executeDiagnosticsTask';
import { waitForDiagnosticsInitialization } from '../initializeDiagnostics';
import type { DiagnosticsEventName } from '../schema/DiagnosticsEventName';

type SubscriberCallback = <T>(e: DiagnosticEventParams<T>) => void;

export interface DiagnosticEventParams<T> {
    name: DiagnosticsEventName;
    data?: T;
}

const diagnosticsEventEmitter = new EventEmitter();

/**
 * This function will subscribe the caller to requested diagnostic events
 * @param name
 * @param callback run once or every time the event is triggered
 */
export const subscribeToDiagnostics = (
    name: DiagnosticsEventName,
    callback: SubscriberCallback
) => {
    diagnosticsEventEmitter.on(name, callback);
};

/**
 * This function will emit a diagnostic event
 * @param eventParams
 */
export const emitDiagnostics = <T>(eventParams: DiagnosticEventParams<T>) => {
    executeDiagnosticsTask(async () => {
        await waitForDiagnosticsInitialization();
        diagnosticsEventEmitter.emit(eventParams.name, eventParams);
    }, true);
};
